/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { _t } from 'app/utils/i18n';
import React from 'react';

class ErrorBoundary extends React.Component<any> {
  state = { error: null } as any;
  render() {
    if (this.state.error) return <></>;
    else if (this.props?.requiredApiCalls?.some((e: any) => e))
      return (
        <>
          {React.Children.map(this.props?.children, (child: any) => {
            return React.cloneElement(child, {
              className: 'server-error',
              'data-error-massage': _t(
                'basic:still_retrieve_data_from_database'
              ),
            });
          })}
        </>
      );
    else return this.props.children;
  }

  static getDerivedStateFromError(error: string) {
    return { error };
  }
}
export default ErrorBoundary;
